<template>
  <base-section
    :id="id"
  >
    <v-container>
      <base-subheading
        align="center"
        :title="item.title"
        class="text-uppercase"
        space="2"
      />
      <!-- <v-row
        class="mt-5"
        align="center"
        justify="center"
      >
        <v-carousel :show-arrows="false">
          <v-carousel-item
            v-for="(foto,i) in item.galeria"
            :key="i"
            :src="foto"
          />
        </v-carousel>
      </v-row> -->

      <v-row
        class="mt-5"
        align="start"
        justify="center"
      >
        <v-col
          cols="12"
          md="3"
        >
          <base-img
            :src="item.imagenPrincipal"
            class="mr-3 hidden-xs-only"
            contain
            max-width="180"
            width="100%"
          />
        </v-col>

        <v-col
          cols="12"
          md="9"
        >
          <div
            class="caption"
          >
            <h3
              class="mb-2 text-left title font-weight-bold"
            >
              DATOS
            </h3>
            <v-divider />
            <div
              class="grey--text text--darken-1"
            >
              <template
                v-for="(f, n) in ficha"
              >
                <v-row
                  :key="n"
                  class="mx-0 my-3"
                  justify="space-between"
                >
                  <span
                    class="text-uppercase"
                    v-text="f.title"
                  />
                  <strong
                    class="text-uppercase"
                    v-text="f.data"
                  />
                </v-row>
                <v-divider :key="f.title" />
              </template>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionTrabajosSlug',

    props: {
      id: {
        type: String,
        default: 'team-slug',
      },
    },

    data: () => ({
      // imagen: require('@/assets/about.jpg'),
      tlf: '+34 955 776 924',
    }),

    computed: {
      itemsTab () {
        return this.$store.state.staff.itemsTab || []
      },
      puestos () {
        return this.$store.state.staff.puestos || []
      },
      items () {
        return this.$store.state.staff.items || []
      },
      item () {
        const data = this.items.filter(i => i.slug === this.slug)[0]
        if (!this.slug || !data) {
          return {
            title: 'Nombre y Apellidos',
            imagenPrincipal: require('@/assets/team/team_2.jpg'),
            datos: {
              departamento: '-',
              puesto: '-',
              email: '-',
              tlf: '-',
            },
          }
        }
        return {
          title: `${data.nombre} ${data.apellidos}`,
          imagenPrincipal: require(`@/assets/${data.image}`),
          datos: {
            departamento: this.itemsTab[data.dpto],
            puesto: this.puestos[data.puesto],
            email: data.email || 'administracion@rosmarsl.es',
            tlf: data.tlf || this.tlf,
          },
        }
      },

      slug () {
        return this.$route.params.slug || null
      },

      ficha () {
        const datos = this.item.datos
        const keys = Object.keys(datos)
        const result = []
        keys.forEach(key => {
          result.push({
            title: key,
            data: datos[key],
          })
        })
        return result
      },
    },
  }
</script>
